module.exports = __webpack_public_path__ + "img/icon_wechat.43019e4e.png";